<template>
  <!-- Main -->
  <div id="main" v-title="title">
    <vue-headful
            title="post"
        />
    <!-- Post -->
    <article class="post">
        <header>
          <div class="title">
            <h2>
              <a href="#">{{ post.post_title }}</a>
            </h2>
            <p>{{$t('blog.published')}} {{ $d(new Date(post.post_date.replace(/-/g, "/")), 'short') }}</p>
          </div>
        </header>
        <div class="content">
          <p v-html="post.post_content"></p>
        </div>
      </article>

      <div class="comments">
        <vue-disqus shortname="fernandomt" :identifier="post.post_title"></vue-disqus>
      </div>
  </div>
</template>

<script>
import SyntaxHelper from '../helpers/syntaxHelper.js'
import BlogHelper from "../helpers/blogHelper"

export default {
    name: "Entry",
    computed: {
        post() {
            return this.$route.params.entry
        },
        title() {
          var title = this.$route.params.entry.post_name.replace(/-/g, " ")
          title = title.charAt(0).toUpperCase() + title.slice(1)
          return title
        }
    },
    mounted() {
      BlogHelper.cleanImages(this.$el),
      SyntaxHelper.highlightCode(this.$el)
    }
};
</script>

<style scoped>
 .post >>> img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
